import { render, staticRenderFns } from "./companyInfoButton.vue?vue&type=template&id=d828ea2c"
import script from "./companyInfoButton.vue?vue&type=script&lang=js"
export * from "./companyInfoButton.vue?vue&type=script&lang=js"
import style0 from "./companyInfoButton.vue?vue&type=style&index=0&id=d828ea2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports